import { render, staticRenderFns } from "./simple-select.vue?vue&type=template&id=2fb0a355&scoped=true"
import script from "./simple-select.vue?vue&type=script&lang=js"
export * from "./simple-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb0a355",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fb0a355')) {
      api.createRecord('2fb0a355', component.options)
    } else {
      api.reload('2fb0a355', component.options)
    }
    module.hot.accept("./simple-select.vue?vue&type=template&id=2fb0a355&scoped=true", function () {
      api.rerender('2fb0a355', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MerchantKYC/components/components/simple-select.vue"
export default component.exports